export default __webpack_public_path__ + "static/media/certificate5.6a6f83fd.svg";